<template>
    <div class="ag-list-input mb-4">
        <div class="d-flex">
            <div class="d-flex col-4" style="padding-left: 0 !important;">
                <label class="form-label d-flex" style="height: min-content;"> {{ label }}<Tooltip
                        :text="tooltip || label"><i class="ag-icon ag-icon_table_info small info-icon" /></Tooltip>
                    </label>
            </div>
            <div v-if="!showApplications" class="d-flex gap-2 col-8">

                <div class="ag-input-inside">
                    <InputText v-model="newValue" :placeholder="placeholder" @keydown.enter.prevent="addItem" />
                    <Button class="ag-add-btn" label="Add" @click="addItem" />
                </div>
            </div>
        </div>
        <div v-if="showDiscoveryToggle" class="d-flex " >
            <div class="d-flex col-4" style="padding-left: 0 !important;">
                <label class="form-label ">Discovery Mode</label>
      
                    <i class="ag-icon ag-icon_table_info small info-icon"></i>

            </div>
            <div class="col-8" >
                <ToggleSwitch v-model="discoveryModeProxy" label="" :show-info="false"  />
            </div>
        </div>
        <div class="ml-2 col-12"> 
            <PanelDropdown v-if="showApplications" v-model="folderMap" :label="$t('folderMap')" :options="folderOptions" placeholder="None"
            :tooltip="tooltips.shared.folderMap" :inputType="'fileTypePolicy'"  />
        </div>
        <div v-if="showApplications" class="ml-2 col-12">
            <label class="form-label d-flex" style="height: min-content;"> Folder/File Name<Tooltip
                        :text="tooltip || label"><i class="ag-icon ag-icon_table_info small info-icon" /></Tooltip>
                    </label>
            <div class="ag-input-inside">
                <InputText v-model="newValue" :placeholder="placeholder" @keydown.enter.prevent="addItem" />
                <Button class="ag-add-btn" label="Add" @click="addItem" />
            </div>
        </div>

        <div v-if="items && items.length > 0" class="ag-list-all-div">
            <div v-for="(item, index) in items" :key="index" class="d-flex items-center">

                <div v-if="!hasDropdown" class="d-flex extension-row col-12">
                    <span class="dot">•</span>
                    <span class="ext-text">{{ formatAppWithFolder(item) }}</span>
                    <button class="remove-btn" @click="removeItem(index)">−</button>
                </div>
                <!-- <span v-if="!hasDropdown" class="flex-1">{{ item }}</span> -->
                <template v-else>
                    <div class="extension-row col-5"><span class="dot">•</span>
                        <span class="ext-text">{{ item.fileExtension }}</span>
                        <button class="remove-btn" @click="removeItem(index)">−</button>
                    </div>
                    <Dropdown :modelValue="item.driverActionOverride" :options="ruleOptions" optionLabel="label"
                        optionValue="value" class=" col-7 file-type-dropdown"
                        @update:modelValue="(val) => updateRule(index, val)" placeholder="Select Driver Action" />

                </template>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, defineProps, defineEmits, computed } from "vue";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import Tooltip from "./tooltip.vue";
import ToggleSwitch from "./toggle-switch.vue";
import PanelDropdown from './panelDropdown.vue'
import { useStore } from "@/store";
import tooltips from '@/assets/tooltips/en.json'

const store = useStore();
const props = defineProps({
    label: { type: String, required: true },
    placeholder: { type: String, default: "" },
    items: { type: Array, required: true },
    hasDropdown: { type: Boolean, default: false },
    tooltip: { type: String, default: "" },
    discoveryMode: { type: Boolean, default: false },
    showDiscoveryToggle: { type: Boolean, default: false },
    showApplications:{type: Boolean, default: false }
});

const emit = defineEmits(["update:items", "update:discoveryMode"]);

const discoveryModeProxy = computed({
    get: () => props.discoveryMode,
    set: (val) => emit("update:discoveryMode", val),
});
const folderOptions = computed(() => {
    const original = store.state.general.folderMaps || [];
    return [{ label: "None", value: 0 }, { label: "Any", value: -1 }, ...original];
});

const folderMap = ref(null);
const newValue = ref("");

function addItem() {
    if (!newValue.value) return;

    let val = newValue.value.trim();

    if (props.hasDropdown) {

        if (val && !val.startsWith(".")) {
            val = "." + val;
        }

        const item = {
            fileExtension: val,
            driverActionOverride: null
        };

        emit("update:items", [...(props.items || []), item]);
    } else {

        const item = {
            applicationPath: val,
            folderMap: folderMap.value
        };

        emit("update:items", [...(props.items || []), item]);
    }

    newValue.value = "";
}

function removeItem(index) {
    const copy = [...props.items];
    copy.splice(index, 1);
    emit("update:items", copy);
}


function updateRule(index, rule) {
    const copy = [...props.items];
    copy[index] = { ...copy[index], driverActionOverride: rule };
    emit("update:items", copy);
}
function getFolderNameById(value) {
    const folderMaps = store.state.general.folderMaps;
    const folder = folderMaps.find((item) => item.value === value);
    return folder?.label;
}

function formatAppWithFolder(item){
    const app = String(item.applicationPath || '').replace(/^\*\\/, '');
    const label =item.isFolderMapIdAny? getFolderLabel(item.folderMap,item.isFolderMapIdAny): getFolderLabel(item.folderMap,null);
    if (label === 'None') return app;
    if(label === 'Any') return `[*]\\${app}`;
    return `[${label}]\\${app}`;
}

const ruleOptions = [
    { label: "Conditional - Apply Runtime Rules", value: "Conditional - Apply Runtime Rules" },
    { label: "Allow - Always Allow Access", value: "Allow - Always Allow Access" },
    { label: "Deny - Always Deny Access", value: "Deny - Always Deny Access" },
];

function getFolderLabel(folderMap,isFolderMapIdAny) {
    if ((folderMap === 0 || folderMap === null) && isFolderMapIdAny) return 'Any';
    else if(folderMap === -1) return 'Any';
    else if (folderMap === null || folderMap === undefined) return 'None';
    else return getFolderNameById(folderMap);
}
</script>
<style scoped>
::v-deep(.p-inputtext) {
  font-size: 0.875rem !important;
  padding: 0.25rem 0.5rem;
}
::v-deep(.p-dropdown-trigger) {
  justify-content: end;
  margin-right: 0.5rem;
}
.ag-list-all-div {
    background: #f0f7ff;
    padding: 1rem;
}

.ag-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    color: #1f5aa6;
    margin-bottom: 6px;
}

.ag-info {
    font-size: 12px;
    color: #94a3b8;
}

.ag-input-inside {
    --add-btn-width: 50px;
    --add-btn-gap: 6px;
    position: relative;
    width: 100%;
}

.ag-input-inside :deep(.p-inputtext) {
    width: 100%;
    font-size: 14px;
    height: 32px;
    padding-right: calc(var(--add-btn-width) + var(--add-btn-gap) + 8px);
}

.ag-add-btn {
    position: absolute;
    top: 50%;
    right: 4px;
    transform: translateY(-50%);
    width: var(--add-btn-width);
    height: calc(100% - 8px);
    padding: 0 8px;
    border-radius: 6px;
    background: #0b3d6d !important;
    border: 1px solid #0b3d6d !important;
    color: #fff !important;
    font-size: 0.7rem !important;
}

.ag-item-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f4f6fb;
    border-radius: 6px;
    padding: 6px 10px;
    margin-top: 8px;
    font-size: 13px;
}

.ag-item-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 75%;
}

.extension-row {
    display: flex;
    align-items: center;
    padding: 0;
    margin-bottom: 8px;
    border-radius: 4px;
}

.dot {
    color: #2f7ecf;
    font-size: 25px;
    margin-right: 6px;

}

.ext-text {
    font-weight: 500;
    padding-right: 8px;
    border-right: 1px solid #94a4b9;
}

.remove-btn {
    width: 18px;
    height: 18px;
    margin-left: 6px;
    margin-right: 8px;
    border-radius: 50%;
    border: none;
    color: #fff;
    background: #94a4b9;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    text-align: center;
    padding: 0;
}

.small-dropdown {
    padding: 4px 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.file-type-dropdown {
    padding: 0.25rem 0.5rem;
    height: 32px;
    align-items: center;
}

</style>
